import { RouteConfig } from 'config/constants/route'
import { ColumnCenter } from 'layout/Components/Column'
import { Trans, useTranslation } from 'react-i18next'
import Button from 'UIKit/Button'
import Image from 'UIKit/Image'
import Link from 'UIKit/Link'
import Text from 'UIKit/Text'

const TournamentEmpty: React.FC = () => {
  const { t } = useTranslation()

  return (
    <ColumnCenter position="relative" padding="20px" paddingBottom="78px">
      <Image
        src="/images/tournament/tournament-empty.png"
        width={200}
        height={200}
        style={{ filter: 'grayscale(100%)' }}
      />
      <Text fontSize="14px" fontWeight={500} color="textSubtle" mt="16px">
        {t('Tournament is not available at the moment! We will come back soon with more challenge for you.')}
      </Text>
      <Text fontSize="14px" fontWeight={500} color="textSubtle" mt="20px">
        <Trans
          i18nKey="tournamentEmptyContent"
          components={{
            highlight_text: <Text as="span" fontSize="14px" fontWeight={700} />,
          }}
        />
      </Text>

      <Button
        as={Link}
        href={RouteConfig.BonusCenter}
        mt="30px"
        height="48px"
        fontSize="14px"
        fontWeight={700}
        style={{ position: 'absolute', left: '20px', right: '20px' }}
      >
        <Trans>Bonus Center</Trans>
      </Button>
    </ColumnCenter>
  )
}

export default TournamentEmpty
